"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelHeader = exports.PanelFooter = exports.PanelBody = exports.Panel = void 0;
var React = _interopRequireWildcard(require("react"));
var _useMountTransition = _interopRequireDefault(require("../../hooks/useMountTransition"));
var _motion = require("../../styles/variables/_motion");
var _space = require("../../styles/variables/_space");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _Button = require("../Button");
var _Modal = require("../Modal");
var _Truncate = require("../Truncate");
var _PanelModule = _interopRequireDefault(require("./Panel.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const getDefaultPanelAnimation = anchor => ({
  // Configure both open and close durations:
  duration: {
    open: parseInt(_motion.motionDurationSlow),
    close: parseInt(_motion.motionDurationNormal)
  },
  initial: {
    transform: `translateX(${anchor === 'right' ? _space.spaceFluid : _space.spaceNegFluid})`
  },
  open: {
    transform: `translateX(${_space.spaceNone})`
  },
  close: {
    transform: `translateX(${anchor === 'right' ? _space.spaceFluid : _space.spaceNegFluid})`
  }
});
const PanelHeader = _ref => {
  let {
    children,
    hideCloseBtn,
    onCloseButtonClick,
    className,
    size,
    testId
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: React.Children.count(children) > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classify.default)(_PanelModule.default.panelHeader, className),
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'header'
      }),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _PanelModule.default.headerContent,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Truncate.Truncate, {
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'title'
          }),
          children: children
        })
      }), !hideCloseBtn && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        iconLeftName: "xmark",
        type: "ghost",
        onClick: onCloseButtonClick,
        ariaLabel: "Close Button",
        size: size,
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'close-button'
        })
      })]
    })
  });
};
exports.PanelHeader = PanelHeader;
const PanelBody = exports.PanelBody = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    children,
    className,
    testId
  } = _ref2;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: ref,
    className: (0, _classify.default)(_PanelModule.default.panelBody, className),
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'body'
    }),
    children: children
  });
});
const PanelFooter = _ref3 => {
  let {
    children,
    classNames,
    testId
  } = _ref3;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: React.Children.count(children) > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classify.default)(_PanelModule.default.panelFooter, classNames?.wrapper),
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'footer'
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classify.default)(_PanelModule.default.panelFooterActions, classNames?.actions),
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: 'actions'
        }),
        children: children
      })
    })
  });
};
exports.PanelFooter = PanelFooter;
const Panel = _ref4 => {
  let {
    children,
    isOpen = false,
    size = 'medium',
    anchor = 'left',
    onClose,
    hideBackdrop = true,
    classNames,
    customAnimation,
    tapOutsideToClose = true,
    allowBackgroundInteraction,
    testId,
    ...restPanelProps
  } = _ref4;
  const isTransitioning = (0, _useMountTransition.default)(isOpen, parseInt(_motion.motionDurationNormal));
  const defaultPanelAnimation = getDefaultPanelAnimation(anchor);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, {
    isOpen: isOpen,
    onClose: onClose,
    hideBackdrop: hideBackdrop,
    tapOutsideToClose: allowBackgroundInteraction ? false : tapOutsideToClose,
    allowBackgroundInteraction: allowBackgroundInteraction,
    testId: testId,
    ...restPanelProps,
    classNames: {
      container: (0, _classify.default)(_PanelModule.default.panelContainer, {
        [_PanelModule.default.in]: isTransitioning,
        [_PanelModule.default.open]: isOpen
      }, classNames?.container),
      content: (0, _classify.default)(_PanelModule.default.panel, _PanelModule.default[anchor], {
        [_PanelModule.default.medium]: size === 'medium',
        [_PanelModule.default.small]: size === 'small',
        [_PanelModule.default.large]: size === 'large'
      }, classNames?.content),
      backdrop: (0, _classify.default)(classNames?.backdrop)
    },
    customAnimation: customAnimation || defaultPanelAnimation,
    children: children
  });
};
exports.Panel = Panel;